export default __webpack_public_path__ + "static/media/nftBackground.e4ec1ebf.jpeg";